(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (() => {
    const warmVideo = (video) => {
      if (!video || video.dataset.jaDeferredVideoLoaded === 'true') return;
      video.load();
      video.dataset.jaDeferredVideoLoaded = 'true';
    };

    const scheduleWarmup = (video) => {
      if (!video || video.dataset.jaDeferredVideoWarmupScheduled === 'true') return;
      video.dataset.jaDeferredVideoWarmupScheduled = 'true';

      window.setTimeout(() => {
        warmVideo(video);
      }, 4000);
    };

    const initDeferredSlideVideos = (root = document) => {
      root.querySelectorAll('slideshow-slide').forEach((slide) => {
        const video = slide.querySelector('.slide__video--deferred');
        if (!video || video.dataset.jaDeferredVideoReady === 'true') return;

        video.dataset.jaDeferredVideoReady = 'true';
        scheduleWarmup(video);

        const syncVideoState = () => {
          const isActive = slide.getAttribute('aria-hidden') !== 'true' && !slide.hidden;

          if (isActive) {
            warmVideo(video);

            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        };

        const observer = new MutationObserver(syncVideoState);
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['aria-hidden', 'hidden'],
        });

        syncVideoState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initDeferredSlideVideos(document), { once: true });
    } else {
      initDeferredSlideVideos(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initDeferredSlideVideos(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'pointerdown',
    function (event) {
      const contactForm = event.target.closest('.contact-form');

      if (!contactForm) return;

      contactForm.dataset.inputMode = 'pointer';
    },
    true
  );


  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Tab') return;

      document.querySelectorAll('.contact-form').forEach(function (contactForm) {
        contactForm.dataset.inputMode = 'keyboard';
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
